var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{on:{"submit":_vm.handleSubmit}},[_c('div',{class:this.fieldClass()},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"stripe-card",attrs:{"id":`payment-element-${_vm.key}`}}),_c('label',{staticClass:"field-status",attrs:{"id":"payment-validation"}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }